

































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { ImportStatusReasonsFormInterface, ImportStatusReasonsFormModel } from '@/components/form/ImportStatusReasonsForm.vue'
import { Pipeline } from '@/api/model/pipeline'
import { Status } from '@/api/model/status'
import { ReferralStatus } from '@/api/types'
import { StatusReasonAPI } from '@/api/backend-client'
import { v4 as uuid } from 'uuid'

@Component
export default class ImportStatusReasonsModal extends Vue {
    @Prop() readonly pipeline!: Pipeline
    @Prop() readonly status!: Status
    @Prop() readonly value!: boolean
    loading: boolean = false
    visible: boolean = false

    importStatusReasonsForm: ImportStatusReasonsFormInterface = null

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }

    mounted() {
        this.importStatusReasonsForm = new ImportStatusReasonsFormModel()
    }

    async importStatusReasons(): Promise<void> {
        this.loading = true

        if (this.status.status === ReferralStatus.OPEN) {
            await this.importPhaseStatusReasons()
        } else {
            await this.importPipelineStatusReasons()
        }

        this.loading = false
        this.$emit('on-save')
    }

    private async importPhaseStatusReasons() {
        const importableStatusReasons = await StatusReasonAPI.getAll({
            status: this.importStatusReasonsForm.status.status,
            pipeline: this.importStatusReasonsForm.pipeline.id,
            phases: this.importStatusReasonsForm.fromPhase.id,
        })

        const promises = []

        importableStatusReasons.forEach(statusReason => {
            const clone = cloneDeep(statusReason)
            clone.id = uuid()
            clone.pipeline = this.pipeline
            clone.status = this.status.status
            clone.phases = [this.importStatusReasonsForm.toPhase]

            promises.push(StatusReasonAPI.create(clone))
        })

        await Promise.all(promises)
        this.$emit('on-save')

        this.visible = false
    }

    private async importPipelineStatusReasons() {
        const importableStatusReasons = await StatusReasonAPI.getAll({
            status: this.importStatusReasonsForm.status.status,
            pipeline: this.importStatusReasonsForm.pipeline.id,
        })

        const promises = []

        importableStatusReasons.forEach(statusReason => {
            const clone = cloneDeep(statusReason)
            clone.id = uuid()
            clone.pipeline = this.pipeline
            clone.status = this.status.status

            promises.push(StatusReasonAPI.create(clone))
        })

        await Promise.all(promises)
        this.$emit('on-save')

        this.visible = false
    }
}
